import i18n from '@/i18n';
import { addMethod as yupAddMethod, setLocale as yupSetLocale, string as yupString } from 'yup';

function setupYupLocale() {
	yupSetLocale({
		mixed: {
			required: ({ label, path }) => i18n.global.t('common.validation.required', { label: label || path }),
		},
		string: {
			email: ({ label, path }) => i18n.global.t('common.validation.email', { label: label || path }),
			min: ({ label, min, path }) => i18n.global.t('common.validation.min', { label: label || path, min }),
			max: ({ label, max, path }) => i18n.global.t('common.validation.max', { label: label || path, max }),
			matches: ({ label, path }) => i18n.global.t('common.validation.matches', { label: label || path }),
		},
	});
}

export function useYupExtensions() {
	setupYupLocale();

	// Watch for language changes and update yup locale
	if (typeof window !== 'undefined' && 'BroadcastChannel' in window) {
		const broadcast = new BroadcastChannel('settings');
		broadcast.addEventListener('message', event => {
			if (event.data === 'update') {
				setupYupLocale();
			}
		});
	}

	yupAddMethod(yupString, 'zipCode', function (msg) {
		return this.matches(/(^\d{5}$)|(^\d{5}-\d{4}$)/, { message: msg || '${path} must be a valid Zip Code.', excludeEmptyString: true });
	});
	yupAddMethod(yupString, 'phoneNumber', function (msg) {
		/**
		 * The MIT License (MIT)
		 * Copyright Jörn Zaefferer
		 * From https://github.com/jquery-validation/jquery-validation/blob/master/src/additional/phoneUS.js
		 * Retrieved 2021-04-14 from commit b9c793c90b3bab1aa9065e4dd4a7d60a9acc0030
		 *
		 * Matches US phone number format
		 *
		 * where the area code may not start with 1 and the prefix may not start with 1
		 * allows '-' or ' ' as a separator and allows parens around area code
		 * some people may want to put a '1' in front of their number
		 *
		 * 1(212)-999-2345 or
		 * 212 999 2344 or
		 * 212-999-0983
		 *
		 * but not
		 * 111-123-5434
		 * and not
		 * 212 123 4567
		 */
		const pattern = /^(\+?1-?)?(\([2-9]([02-9]\d|1[02-9])\)|[2-9]([02-9]\d|1[02-9]))-?[2-9]\d{2}-?\d{4}$/;
		return this.matches(pattern, { message: msg || '${path} must be a valid phone number.', excludeEmptyString: true });
	});
}
